import { DateMarshaller } from '../../marshallers'
import { Marshaller } from '../../types/core'
import { ChatMessage, ChatMessageResource } from './types'

export const chatMessageMarshaller: Marshaller<ChatMessage, ChatMessageResource> = {
  marshal: ({ sentAt, ...rest }) => ({ sentAt: DateMarshaller.marshal(sentAt), ...rest }),
  unmarshal: ({ sentAt, ...rest }) => ({ sentAt: DateMarshaller.unmarshal(sentAt), ...rest }),
}
